import ky, { HTTPError } from 'ky';
import { ENV } from 'src/utils/env';
import { STORES_CONFIG_GET_RESPONSE_SCHEMA, STORES_CONFIG_SCHEMA, StoreConfigSchema } from './storesSchema';

export const retrieveStorePromise = async (params: StoreConfigSchema) => {
  const parsedParams = STORES_CONFIG_SCHEMA.safeParse(params);

  if (!parsedParams.success) {
    throw new Error('invalid params');
  }

  try {
    const response = await ky.post(`${ENV.FRONTEND_API_URL}/stores`, {
      body: JSON.stringify(parsedParams.data),
    });

    const validatedResponse = STORES_CONFIG_GET_RESPONSE_SCHEMA.safeParse(await response.json());

    if (!validatedResponse.success) {
      console.error('Error in Response', validatedResponse.error);
      throw new Error('Error in Response', validatedResponse.error);
    }
    const base = validatedResponse?.data.data[0];

    if (!base || typeof base !== 'object') {
      throw new Error('Invalid response');
    }

    return base;
  } catch (error) {
    if (error instanceof HTTPError) {
      let errorRes = error;

      try {
        errorRes = await error.response.json();
      } catch {
        //
      }

      throw new Error(errorRes?.message);
    }

    throw new Error((error as Error)?.message || 'Error while getting store');
  }
};

export type StoreDetailsResponse = Awaited<ReturnType<typeof retrieveStorePromise>>;
